export default "__VITE_ASSET__ChKpK98L__"